import { motion } from "framer-motion";

const OPERATIONS = [
  {
    n: "01",
    title: "Strutturazione dei processi interni",
    desc: "Definizione di funzioni, deleghe, procedure e presidi di controllo. Lo Studio affianca il Management nella costruzione di un'organizzazione legalmente robusta e scalabile.",
    approach: "Mappatura funzioni · deleghe · procedure operative",
    focus: "Ruolo di manager legale esterno, integrato nella governance ordinaria.",
  },
  {
    n: "02",
    title: "Acquisizione quote societarie",
    desc: "Strutturazione di operazioni di acquisizione partecipazioni, anche con coinvolgimento di fondi di private equity.",
    approach: "Due diligence mirata · negoziazione SPA · MAC clauses",
    focus: "Allocazione efficace di rappresentazioni, garanzie e indennizzi.",
  },
  {
    n: "03",
    title: "Sviluppo immobiliare residenziale",
    desc: "Assistenza in tutte le fasi: acquisizione del lotto, permessi, contratti d'appalto, commercializzazione.",
    approach: "Strutturazione contrattuale · presidio urbanistico · varianti",
    focus: "Prevenzione del contenzioso e gestione delle riserve.",
  },
  {
    n: "04",
    title: "Strutturazione accordi tra soci",
    desc: "Patti parasociali, regole di governance, exit, deadlock, drag & tag along, clausole anti-diluizione.",
    approach: "Bilanciamento poteri · meccanismi di uscita · enforcement",
    focus: "Stabilità della governance e tutela del valore della partecipazione.",
  },
  {
    n: "05",
    title: "Contratti EPC e general contractor",
    desc: "Negoziazione e drafting di contratti EPC, appalti complessi e accordi di subappalto industriali.",
    approach: "Risk allocation · milestone · penali · garanzie",
    focus: "Chiarezza operativa e gestione di varianti e riserve.",
  },
  {
    n: "06",
    title: "Recupero crediti industriali",
    desc: "Strategie di recupero per crediti commerciali rilevanti, contestazioni e procedure esecutive.",
    approach: "Analisi documentale · azione tempestiva · garanzie reali",
    focus: "Rapidità di incasso e minimizzazione dell'esposizione.",
  },
  {
    n: "07",
    title: "Operazioni immobiliari complesse",
    desc: "Permute, rent to buy, riqualificazione, valorizzazione e dismissione di asset immobiliari.",
    approach: "Strutturazione fiscale · contrattualistica · presidio rischi",
    focus: "Efficienza dell'operazione e tutela patrimoniale.",
  },
];

export default function TrackRecord() {
  return (
    <section
      id="operazioni"
      className="relative py-24 lg:py-32 border-t border-[#FAF9F6]/10"
      data-testid="track-record-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16 max-w-3xl">
          <div className="overline mb-4">Ambiti di Intervento</div>
          <h2 className="font-display text-4xl lg:text-6xl font-medium leading-[1.02] tracking-tight">
            Assistenza legale
            <span className="block text-[#FAF9F6]/50 italic font-normal">
              nelle scelte che contano.
            </span>
          </h2>
          <p className="mt-6 max-w-xl text-[15px] text-[#FAF9F6]/60 leading-relaxed">
            Dallo strutturare processi e presidi interni fino alle operazioni
            straordinarie: lo Studio affianca l&apos;impresa nell&apos;intero
            ciclo di vita del business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0A0A0A]/15 border border-[#0A0A0A]/15">
          {OPERATIONS.map((op, i) => (
            <motion.div
              key={op.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="bg-[#EAECE7] text-[#0A0A0A] p-8 lg:p-10 hover:bg-[#F2F3EE] transition-colors group"
              data-testid={`operation-card-${op.n}`}
            >
              <div className="flex items-center gap-3 mb-8">
                <span className="inline-flex items-center justify-center h-7 min-w-[36px] px-2 bg-[#0A0A0A] text-[#C5A880] font-display text-[13px] tracking-wider">
                  {op.n}
                </span>
                <span className="text-[10px] tracking-[0.22em] uppercase font-semibold text-[#1B3B36]">
                  Assistenza legale
                </span>
              </div>
              <h3 className="font-display text-xl lg:text-2xl font-medium leading-tight tracking-tight mb-4">
                {op.title}
              </h3>
              <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">
                {op.desc}
              </p>
              <div className="mt-8 pt-6 border-t border-[#0A0A0A]/12 space-y-3 text-[12px]">
                <div>
                  <div className="text-[9px] tracking-[0.22em] uppercase font-semibold text-[#1B3B36] mb-1">
                    Approccio
                  </div>
                  <div className="text-[#0A0A0A]/80">{op.approach}</div>
                </div>
                <div>
                  <div className="text-[9px] tracking-[0.22em] uppercase font-semibold text-[#1B3B36] mb-1">
                    Focus rischio
                  </div>
                  <div className="text-[#0A0A0A]/80">{op.focus}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
